<section
  *ngIf="{ queryParams: queryParams$ | async } as resolved"
  data-testid="sidebar"
  class="s-full tw-shadow p-2 fx-col overflow-y-auto"
  customerScreenType>
  <ng-container *ngIf="system; else noSystem">
    <lib-selected-system-support
      [system]="system"
      (systemDefinition)="systemDefinition$.next($event)">
    </lib-selected-system-support>

    <customer-menu *ngIf="(systems?.length || 0) > 1">
      <customer-menu-router-item
        [routerLink]="resolved.queryParams?.source === 'service' ? ['/', 'service', 'my-plants'] : ['/']"
        [tooltipText]="'i18n.Common.plants' | translate"
        (click)="$event.stopPropagation()">
        <mat-icon>arrow_back</mat-icon>
        <span>
          {{ "i18n.Common.plants" | translate }}
        </span>
        <customer-menu
          menu-item-content
          class="mt-1"
          [secondary]="true"
          (click)="$event.stopPropagation()">
          <customer-menu-router-item
            routerLink="overview"
            routerLinkActive="active"
            [tooltipText]="system.name">
            <mat-icon fontIcon="home"></mat-icon>
            <span
              data-testid="sidebar-plant-name"
              class="body-3">
              {{ system.name }}
            </span>
          </customer-menu-router-item>
        </customer-menu>
      </customer-menu-router-item>
    </customer-menu>

    <customer-menu *ngIf="systems?.length === 1">
      <customer-menu-router-item
        routerLink="overview"
        routerLinkActive="active"
        [tooltipText]="system.name">
        <mat-icon fontIcon="home"></mat-icon>
        <span
          data-testid="sidebar-plant-name"
          class="body-3">
          {{ system.name }}
        </span>
      </customer-menu-router-item>
    </customer-menu>

    <lib-plant-card-overview
      class="p-3 bg-grey-100 my-1 radius-4 border-1 border-grey-300"
      headerType="plantStatus"
      [labels]="{
        connectedAndUpdated: 'i18n.Common.connectedWithUpdatedTelemetry' | translate,
        disconnected: 'i18n.Common.disconnected' | translate,
        updated: 'i18n.Common.updated' | translate,
        notUpdated: 'i18n.Common.telemetryNotUpdated' | translate,
        hasAlerts: 'i18n.DeviceRegistry.isInAlarm' | translate,
      }"
      [system]="system"
      [refresh$]="refresh$">
    </lib-plant-card-overview>

    <customer-menu>
      <customer-menu-router-item
        routerLink="devices"
        routerLinkActive="active"
        [tooltipText]="'i18n.Sidebar.devices' | translate">
        <mat-icon fontIcon="account_tree"></mat-icon>
        <span>
          {{ "i18n.Sidebar.devices" | translate }}
        </span>

        <customer-menu
          *ngIf="currentSystemDevices"
          menu-item-content
          class="my-1"
          [secondary]="true">
          <customer-menu-router-item
            *ngFor="let device of currentSystemDevices"
            routerLink="/customer/plants/{{ system.uid }}/devices/{{ device.id.toUpperCase() }}"
            routerLinkActive="active"
            [tooltipText]="device.id"
            (click)="$event.stopPropagation()">
            <mat-icon [svgIcon]="device.id | apply : getDeviceIconIdentifier"></mat-icon>
            <span class="body-3">
              {{ device.id | uppercase }}
            </span>
          </customer-menu-router-item>
        </customer-menu>

        <customer-menu
          *ngIf="currentSystemDevices === null"
          menu-item-content
          class="my-1"
          [secondary]="true">
          <customer-menu-router-item
            *ngFor="let _ of [1, 2, 3]"
            class="skeleton-menu-border-style">
            <ion-skeleton-text
              animated
              class="w-3p">
            </ion-skeleton-text>
            <ion-skeleton-text
              animated
              class="w-7p">
            </ion-skeleton-text>
          </customer-menu-router-item>
        </customer-menu>
      </customer-menu-router-item>

      <customer-menu
        *ngIf="currentSystemDevices === null"
        menu-item-content
        class="my-1"
        [secondary]="true">
        <customer-menu-router-item
          *ngFor="let _ of [1, 2, 3]"
          class="skeleton-menu-border-style">
          <ion-skeleton-text
            animated
            class="w-3p">
          </ion-skeleton-text>
          <ion-skeleton-text
            animated
            class="w-7p">
          </ion-skeleton-text>
        </customer-menu-router-item>
      </customer-menu>

      <customer-menu-router-item
        *ngIf="areEvManaged"
        routerLinkActive="active"
        [routerLink]="(canEditEvchConfig$ | async) ? ['/customer/plants', system.uid, 'evcharge'] : null"
        [tooltipText]="'Gestione ricarica'">
        <mat-icon fontIcon="ev_station"></mat-icon>
        <span>
          {{ "i18n.EvchargeDashboard.title" | translate }}
        </span>
        <customer-menu
          *ngIf="evchargesId"
          menu-item-content
          class="my-1"
          [secondary]="true">
          <customer-menu-router-item
            *ngFor="let ev of evchargesId"
            routerLink="/customer/plants/{{ system.uid }}/evcharge/{{ ev.toUpperCase() }}"
            routerLinkActive="active"
            [tooltipText]="ev"
            (click)="$event.stopPropagation()">
            <mat-icon [svgIcon]="ev | apply : getDeviceIconIdentifier"></mat-icon>
            <span class="body-3">
              {{ ev | uppercase }}
            </span>
          </customer-menu-router-item>
        </customer-menu>

      </customer-menu-router-item>

      <customer-menu-router-item
        *ngIf="areHeatPumpManaged"
        routerLinkActive="active"
        [routerLink]="['/customer/plants', system.uid, 'heatpump']"
        [tooltipText]="'i18n.sidebar.heatPump' | translate">
        <mat-icon svgIcon="customer_heatpump_icon"></mat-icon>
        <span>
          {{ "i18n.sidebar.heatPump" | translate }}
        </span>
        <customer-menu
          *ngIf="heatPumpsId"
          menu-item-content
          class="my-1"
          [secondary]="true">
          <customer-menu-router-item
            *ngFor="let hp of heatPumpsId"
            routerLink="/customer/plants/{{ system.uid }}/heatpump/{{ hp.toUpperCase() }}"
            routerLinkActive="active"
            [tooltipText]="hp"
            (click)="$event.stopPropagation()">
            <mat-icon [svgIcon]="hp | apply : getDeviceIconIdentifier"></mat-icon>
            <span class="body-3">
              {{ hp | uppercase }}
            </span>
          </customer-menu-router-item>
        </customer-menu>
      </customer-menu-router-item>

      <customer-menu-router-item
        tooltipText="Report"
        routerLink="report"
        routerLinkActive="active"
        [tooltipText]="'i18n.Common.report' | translate">
        <mat-icon svgIcon="export_notes"></mat-icon>
        <span>
          {{ "i18n.Common.report" | translate }}
        </span>
      </customer-menu-router-item>
      <customer-menu-router-item
        *ngIf="areAlertsManaged$ | async"
        routerLink="alerts"
        routerLinkActive="active"
        [tooltipText]="'i18n.Sidebar.alerts' | translate">
        <mat-icon fontIcon="warning"></mat-icon>
        <span> {{ "i18n.Sidebar.alerts" | translate }} </span>
        <lib-alerts-counter
          [system]="system"
          [refresh$]="refresh$">
        </lib-alerts-counter>
      </customer-menu-router-item>
      <customer-menu-router-item
        *ngIf="areEventsManaged$ | async"
        routerLink="events"
        routerLinkActive="active"
        [tooltipText]="'i18n.Sidebar.alerts' | translate">
        <mat-icon fontIcon="notification_important"></mat-icon>
        <span> {{ "i18n.ServiceSidebar.events" | translate }} </span>
      </customer-menu-router-item>
      <customer-menu-router-item
        routerLink="settings"
        routerLinkActive="active"
        [tooltipText]="'i18n.Sidebar.settings' | translate">
        <mat-icon fontIcon="settings"></mat-icon>
        <span>
          {{ "i18n.Sidebar.settings" | translate }}
        </span>
      </customer-menu-router-item>
      <customer-menu-router-item
        *ngIf="canBeReached && (userHasSomeRole$ | async)"
        routerLink="configurations"
        routerLinkActive="active"
        [tooltipText]="'i18n.Sidebar.plantManagement' | translate">
        <mat-icon fontIcon="cloud_download"></mat-icon>
        <span>
          {{ "i18n.Sidebar.plantManagement" | translate }}
        </span>
      </customer-menu-router-item>
    </customer-menu>
    <ng-container *ngIf="hasMixedMonitoringType">
      <div
        id="monitoring-type"
        class="fx-col p-3 fx-gap-2 mt-auto">
        <span class="tw-text-sm text-grey-400 text-style-italic tw-font-light">{{
          'i18n.Common.monitoringType' | translate
        }}</span>
      </div>

      <customer-menu
        class="asList"
        [value]="currentMonitoringType">
        <customer-menu-item
          *ngFor="let id of availableLoggersTypes"
          [value]="id"
          (click)="updateMonitoringPref($any(id))">
          <mat-icon [svgIcon]="id === 'connext' ? 'customer_connext' : id === 'azzurroHub' ? 'customer_azzurro_hub' : 'customer_other_loggers'">
          </mat-icon>
          <span>{{ (id === 'connext' ? 'i18n.Common.Connext'  : id === 'azzurroHub' ? 'i18n.Common.AzzurroHub' : 'i18n.DeviceDetails.stickOrMeter') | translate }}</span>
        </customer-menu-item>
      </customer-menu>
    </ng-container>
  </ng-container>

  <ng-template #noSystem>

    <div
      id="welcome"
      class="fx-col p-3 tw-text-lg text-400 text-center radius-4 bg-accent border-1 border-accent text-white">
      {{ 'i18n.Welcome.MainTitle' | translate }}
    </div>

    <customer-menu class="as-accent mt-1">
      <customer-menu-item
        value="create"
        class="text-capitalize w-full"
        routerLinkActive="active"
        [routerLink]="['/', 'customer', 'create']">
        <mat-icon fontIcon="add_circle"></mat-icon>
        <span id="new-plant">{{ 'i18n.Common.newPlant' | translate }}</span>
      </customer-menu-item>
      <customer-menu-item
        value="porting"
        class="text-capitalize w-full"
        routerLinkActive="active"
        [routerLink]="['/', 'customer', 'porting']">
        <mat-icon fontIcon="keyboard_double_arrow_up"></mat-icon>
        <span id="promote-plant">{{ 'i18n.Common.promotePlants' | translate }}</span>
      </customer-menu-item>
      <customer-menu-item
        value="plants"
        class="text-capitalize w-full"
        routerLinkActive="active"
        [routerLink]="['/', 'customer', 'plants']">
        <mat-icon>list</mat-icon>
        <span id="plant-list">{{ 'i18n.Common.myPlants' | translate }}</span>
      </customer-menu-item>
    </customer-menu>
  </ng-template>
</section>
